import { mapGetters } from 'vuex'
import conf from '../conf/wx.conf'
import { toast } from '../utils/toast'
import handleWxConfig from '@/handler/wx.sdk.handler/wx.conf.handler'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('channel',['channel','campaign'])
  },
  methods: {
    // 组装分享需要的配置参数
    buildParams() {
      const { query } = this.$route
      return {
        ...query,
        channel: this.channel
      }
    },
    // 微信分享
    wxShare(options = {}) {
      let shareUrl = `${location.origin}${location.pathname}#/home?channel=${encodeURIComponent(this.channel)}`
      let Url = location.origin + location.pathname + '/html/redirect.html?app3Redirect=' + encodeURIComponent(shareUrl);

      const params = Object.assign(conf.WX_SHARE_PARAMS,{
        link: `${Url}`
      })
      handleWxConfig(['onMenuShareTimeline','onMenuShareAppMessage']).then(
        () => {
          this.$wx.onMenuShareTimeline({
            ...params
          })
          this.$wx.onMenuShareAppMessage({
            ...params
          })
        }
      )
    }
  }
}
